import React, { useState, useRef, useEffect } from 'react';

type Language = 'en' | 'ar';

const languageMap: Record<Language, { name: string; flag: string }> = {
    en: { name: 'English', flag: '🇺🇸' },
    ar: { name: 'Arabic', flag: '🇸🇦' },
};

const LanguageSelector: React.FC<{
    currentLanguage: Language;
    onChange: (lang: Language) => void;
}> = ({ currentLanguage, onChange }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div ref={ref} className="relative">
            {/* Icon Button */}
            <button
                onClick={() => setOpen(!open)}
                className="w-9 h-9 rounded-full flex items-center justify-center text-xl bg-neutral-800 hover:bg-neutral-700 border border-neutral-700"
                title="Change Language"
            >
                {languageMap[currentLanguage].flag}
            </button>

            {/* Dropdown */}
            {open && (
                <div
                    className={`absolute bottom-12 z-50 w-32 rounded-lg shadow-lg border border-gray-200 bg-white text-sm text-gray-800
          ${currentLanguage === 'ar' ? 'right-0' : 'left-0'}`}
                >
                    {Object.entries(languageMap).map(([lang, { name, flag }]) => (
                        <button
                            key={lang}
                            onClick={() => {
                                onChange(lang as Language);
                                setOpen(false);
                            }}
                            className={`w-full px-3 py-2 text-left flex items-center gap-2 hover:bg-gray-100 ${currentLanguage === lang ? 'font-semibold text-indigo-600' : ''
                                }`}
                        >
                            <span className="text-lg">{flag}</span>
                            <span>{name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSelector;
